import { useConnectionStatus } from './useConnectionStatus';

const TONE_CLASS_NAMES = {
  warning: {
    panel:
      'border-amber-200/80 bg-amber-50/95 text-amber-950 shadow-[0_16px_42px_rgba(245,158,11,0.18)] dark:border-amber-500/30 dark:bg-slate-900/92 dark:text-amber-100',
    eyebrow: 'text-amber-700 dark:text-amber-300',
    iconWrapper:
      'bg-amber-100 text-amber-700 ring-1 ring-amber-200/80 dark:bg-amber-500/16 dark:text-amber-300 dark:ring-amber-500/25',
    icon: 'bg-amber-500',
  },
  danger: {
    panel:
      'border-red-200/80 bg-red-50/95 text-red-950 shadow-[0_16px_42px_rgba(239,68,68,0.18)] dark:border-red-500/30 dark:bg-slate-900/92 dark:text-red-100',
    eyebrow: 'text-red-700 dark:text-red-300',
    iconWrapper:
      'bg-red-100 text-red-700 ring-1 ring-red-200/80 dark:bg-red-500/16 dark:text-red-300 dark:ring-red-500/25',
    icon: 'bg-red-500',
  },
} as const;

export default function ConnectionIssueNotice() {
  const { detail, hasIssue, srLabel, title, tone } = useConnectionStatus();

  if (!hasIssue || !tone || !title) {
    return null;
  }

  const toneClasses = TONE_CLASS_NAMES[tone];

  return (
    <div className="pointer-events-none fixed left-4 right-4 top-3 z-[90] sm:left-auto sm:right-4 sm:top-4 sm:max-w-sm">
      <div
        role="status"
        aria-live="polite"
        aria-label={srLabel}
        className={`pointer-events-auto rounded-2xl border px-4 py-3 backdrop-blur-md animate-in fade-in slide-in-from-top-2 duration-200 ${toneClasses.panel}`}
      >
        <div className="flex items-start gap-3">
          <div
            aria-hidden="true"
            className={`mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full ${toneClasses.iconWrapper}`}
          >
            <span className={`h-2.5 w-2.5 rounded-full ${toneClasses.icon}`} />
          </div>
          <div className="min-w-0">
            <div className={`text-[11px] font-semibold uppercase tracking-[0.22em] ${toneClasses.eyebrow}`}>
              Connection issue
            </div>
            <div className="mt-1 text-sm font-semibold">{title}</div>
            {detail ? (
              <div className="mt-1 text-sm leading-5 text-slate-600 dark:text-slate-300">
                {detail}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
